import { render, staticRenderFns } from "./ActionsForPromotion.vue?vue&type=template&id=28b4d8c6"
import script from "./ActionsForPromotion.vue?vue&type=script&lang=ts"
export * from "./ActionsForPromotion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports